import { AnalysisItem, LegendItem } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import { sortArray } from "components/results/analysis-results/sortUtil";
import getLineChart from "../../echart/line-chart";
import gap from "report/common/gap";
import getTitle from "report/common/title";
import getNumberOfLocations from "./location-count/index";
import { buildPreparedHazardOverviewData } from "../build-prepared-overview-data";

const get = async (
  t: any,
  analysisItems: AnalysisItem[],
  legendItems: LegendItem[],
  aggregationUnits: string[],
  lineSeries?: any[]
): Promise<Content[]> => {
  const hasLineSeries = !!lineSeries?.length;

  const { ignoredLayerIds } = buildPreparedHazardOverviewData(
    analysisItems,
    legendItems
  );
  ignoredLayerIds.sort((a, b) => sortArray.indexOf(a) - sortArray.indexOf(b));

  return [
    getTitle(t("report.Analysis Overview")),
    gap(10),
    ...(hasLineSeries
      ? [await getLineChart(t, lineSeries!, ignoredLayerIds)]
      : [])
    // aggregationUnits.includes("numberOfLocations")
    //   ? await getNumberOfLocations(t, analysisItems, legendItems)
    //   : []
  ];
};

export default get;
